import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchRegisterDownloadRequestsQueryVariables = Types.Exact<{
  input: Types.RegisterDownloadRequestsInput;
}>;


export type FetchRegisterDownloadRequestsQuery = { readonly __typename?: 'Query', readonly registerDownloadRequests: { readonly __typename?: 'RegisterDownloadRequestPage', readonly limit?: number | null, readonly offset?: number | null, readonly requests: ReadonlyArray<{ readonly __typename?: 'RegisterDownloadRequest', readonly id: string, readonly registerType: Types.RegisterType, readonly selectedColumns?: ReadonlyArray<string | null> | null, readonly clinic: { readonly __typename?: 'Clinic', readonly name: string }, readonly actor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly filters: { readonly __typename?: 'DownloadRegisterFilters', readonly startDate: string, readonly endDate: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly download?: { readonly __typename?: 'RegisterDownload', readonly id: string, readonly status: Types.RegisterDownloadStatus, readonly result?: { readonly __typename?: 'RegisterRecordDownload', readonly expiresAt?: string | null } | null } | null } | null> } };

export type DownloadRequestFragmentFragment = { readonly __typename?: 'RegisterDownloadRequest', readonly id: string, readonly registerType: Types.RegisterType, readonly selectedColumns?: ReadonlyArray<string | null> | null, readonly clinic: { readonly __typename?: 'Clinic', readonly name: string }, readonly actor: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly filters: { readonly __typename?: 'DownloadRegisterFilters', readonly startDate: string, readonly endDate: string }, readonly meta?: { readonly __typename?: 'Meta', readonly created?: string | null, readonly updated?: string | null } | null, readonly download?: { readonly __typename?: 'RegisterDownload', readonly id: string, readonly status: Types.RegisterDownloadStatus, readonly result?: { readonly __typename?: 'RegisterRecordDownload', readonly expiresAt?: string | null } | null } | null };

export type DownloadRegisterResultQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DownloadRegisterResultQuery = { readonly __typename?: 'Query', readonly registerDownloadRequest: { readonly __typename?: 'RegisterDownloadRequest', readonly download?: { readonly __typename?: 'RegisterDownload', readonly result?: { readonly __typename?: 'RegisterRecordDownload', readonly expiresAt?: string | null, readonly password: string, readonly records: string } | null } | null } };

export const DownloadRequestFragmentFragmentDoc = gql`
    fragment DownloadRequestFragment on RegisterDownloadRequest {
  id
  registerType
  clinic {
    name
  }
  actor {
    person {
      firstname
      lastname
    }
  }
  filters {
    startDate
    endDate
  }
  selectedColumns
  meta {
    created
    updated
  }
  download {
    id
    status
    result {
      expiresAt
    }
  }
}
    `;
export const FetchRegisterDownloadRequestsDocument = gql`
    query FetchRegisterDownloadRequests($input: RegisterDownloadRequestsInput!) {
  registerDownloadRequests(input: $input) {
    limit
    offset
    requests {
      ...DownloadRequestFragment
    }
  }
}
    ${DownloadRequestFragmentFragmentDoc}`;

/**
 * __useFetchRegisterDownloadRequestsQuery__
 *
 * To run a query within a React component, call `useFetchRegisterDownloadRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegisterDownloadRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegisterDownloadRequestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchRegisterDownloadRequestsQuery(baseOptions: Apollo.QueryHookOptions<FetchRegisterDownloadRequestsQuery, FetchRegisterDownloadRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRegisterDownloadRequestsQuery, FetchRegisterDownloadRequestsQueryVariables>(FetchRegisterDownloadRequestsDocument, options);
      }
export function useFetchRegisterDownloadRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRegisterDownloadRequestsQuery, FetchRegisterDownloadRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRegisterDownloadRequestsQuery, FetchRegisterDownloadRequestsQueryVariables>(FetchRegisterDownloadRequestsDocument, options);
        }
export type FetchRegisterDownloadRequestsQueryHookResult = ReturnType<typeof useFetchRegisterDownloadRequestsQuery>;
export type FetchRegisterDownloadRequestsLazyQueryHookResult = ReturnType<typeof useFetchRegisterDownloadRequestsLazyQuery>;
export type FetchRegisterDownloadRequestsQueryResult = Apollo.QueryResult<FetchRegisterDownloadRequestsQuery, FetchRegisterDownloadRequestsQueryVariables>;
export const DownloadRegisterResultDocument = gql`
    query DownloadRegisterResult($id: ID!) {
  registerDownloadRequest(id: $id) {
    download {
      result {
        expiresAt
        password
        records
      }
    }
  }
}
    `;

/**
 * __useDownloadRegisterResultQuery__
 *
 * To run a query within a React component, call `useDownloadRegisterResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadRegisterResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadRegisterResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadRegisterResultQuery(baseOptions: Apollo.QueryHookOptions<DownloadRegisterResultQuery, DownloadRegisterResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadRegisterResultQuery, DownloadRegisterResultQueryVariables>(DownloadRegisterResultDocument, options);
      }
export function useDownloadRegisterResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadRegisterResultQuery, DownloadRegisterResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadRegisterResultQuery, DownloadRegisterResultQueryVariables>(DownloadRegisterResultDocument, options);
        }
export type DownloadRegisterResultQueryHookResult = ReturnType<typeof useDownloadRegisterResultQuery>;
export type DownloadRegisterResultLazyQueryHookResult = ReturnType<typeof useDownloadRegisterResultLazyQuery>;
export type DownloadRegisterResultQueryResult = Apollo.QueryResult<DownloadRegisterResultQuery, DownloadRegisterResultQueryVariables>;